import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";

const WhyOwnOshar = ({ benefits }) => {
  return (
    <section className="oshar-re-why" aria-labelledby="oshar-re-why-title">
      <div className="oshar-inner oshar-re-why__inner">
        <div className="oshar-re-why__copy">
          <h2 id="oshar-re-why-title" className="oshar-re-section-title">
            Why Own in Oshar
          </h2>
          <ul className="oshar-re-why__list">
            {benefits.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
          <p className="oshar-re-why__callout">
            Commerce should deepen the world, not break the game.
          </p>
        </div>
        <div className="oshar-re-why__visual">
          <img src={VR_RE_IMAGES.balconyCity} alt="Overlook of the golden circular city of Oshar" />
          <div className="oshar-re-why__frame" aria-hidden />
        </div>
      </div>
    </section>
  );
};

export default WhyOwnOshar;
